module.exports = __webpack_public_path__ + "img/NE_STL.b13c2973.jpg";